import React, { useRef, useState } from 'react';

import { StandardEventProperties } from '@betterment/js-runtime';
import { Box, Text } from '@betterment/samba-react';
import { Button, Flex, TabularNumber } from '@betterment/style-closet-react';
import styled from '@emotion/styled';
import copy from 'copy-to-clipboard';

import { trackClick } from '../../features/track';

const FadeInText = styled(Text)`
  animation: fade 1s ease;

  @keyframes fade {
    0% {
      opacity: 0;
    }
    15%,
    85% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`;

interface Props {
  label: string;
  value: number | string;
  trackingProperties: StandardEventProperties;
  title: string;
}

const CopyableNumber: React.FC<React.PropsWithChildren<Props>> = ({ label, value, trackingProperties, title }) => {
  const [isCopied, setCopied] = useState(false);
  const copyRef = useRef<HTMLElement>(null);

  const copyNumber = () => {
    if (copyRef.current) {
      copy(copyRef.current.innerHTML);

      setCopied(true);

      setTimeout(() => {
        setCopied(false);
      }, 1000);
    }
  };

  return (
    <Flex justifyContent="space-between">
      <Box>
        <Text as="p" variant="text100" css={{ mb: 'space.100', lineHeight: 'lineHeight.100' }}>
          {label}
        </Text>
        <TabularNumber>
          <Text color="text.placeholder" css={{ padding: 'space.0' }} ref={copyRef}>
            {value}
          </Text>
        </TabularNumber>
      </Box>
      <Box>
        {isCopied ? (
          <FadeInText color="text.placeholder" role="alert">
            Copied
          </FadeInText>
        ) : (
          <Button
            variant="tertiary"
            title={title}
            p="1"
            onClick={() => {
              trackClick(trackingProperties);
              copyNumber();
            }}
          >
            Copy
          </Button>
        )}
      </Box>
    </Flex>
  );
};

export default CopyableNumber;
